import * as yup from 'yup';

export const validationSchema = yup.object({
    inventoryId: yup.string().typeError("Must be a text").required("Required"),
    effectiveDate: yup.date().typeError("Must be a valid date").required("Required"),
    previousSellingPrice: yup.number().typeError("Must be a valid number").required("Required"),
    newSellingPrice: yup.number().typeError("Must be a valid number").required("Required"),

})